var _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrownext(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5955 31.8614C26.3031 31.5691 26.1628 31.2158 26.1745 30.8016C26.1862 30.3874 26.3387 30.0341 26.6321 29.7417L30.7619 25.6119H14.4619C14.0477 25.6119 13.7002 25.4715 13.4196 25.1909C13.1389 24.9102 12.999 24.5632 13 24.15C13 23.7358 13.1403 23.3884 13.421 23.1077C13.7017 22.827 14.0487 22.6871 14.4619 22.6881H30.7619L26.5955 18.5217C26.3031 18.2294 26.157 17.8819 26.157 17.4794C26.157 17.0769 26.3031 16.73 26.5955 16.4386C26.8879 16.1462 27.2353 16 27.6378 16C28.0404 16 28.3873 16.1462 28.6787 16.4386L35.3668 23.1267C35.513 23.2729 35.6168 23.4312 35.6782 23.6018C35.7396 23.7723 35.7698 23.9551 35.7688 24.15C35.7688 24.3449 35.7381 24.5277 35.6767 24.6982C35.6153 24.8688 35.512 25.0271 35.3668 25.1733L28.6422 31.898C28.3741 32.166 28.0394 32.3 27.6378 32.3C27.2363 32.3 26.8889 32.1538 26.5955 31.8614Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 3.5,
    stroke: "#5A7787"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrownext);
export default __webpack_public_path__ + "static/media/arrownext.b0ebf028d496a93fb4c1603c164c0698.svg";
export { ForwardRef as ReactComponent };